import { render, staticRenderFns } from "./FailurePage.vue?vue&type=template&id=242d0c9a&scoped=true&"
import script from "./FailurePage.vue?vue&type=script&lang=js&"
export * from "./FailurePage.vue?vue&type=script&lang=js&"
import style0 from "./FailurePage.vue?vue&type=style&index=0&id=242d0c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d0c9a",
  null
  
)

export default component.exports